import { InitAdapter, SubmitAdapter } from '../../types';

const SUBJECT_TAG_IDS = {
  model: 1,
  object: 3,
  character: 4,
  aireference: 5,
};

export const initAdapter: InitAdapter = ({ deviation }) => {
  const { subjectTags, locationTag } = deviation?.extended || {};
  const labels: { type: string; name: string }[] = (subjectTags || []).map(subjectTag => ({
    type: subjectTag.type,
    name: subjectTag.name,
  }));
  if (locationTag) {
    labels.push({
      type: 'location',
      name: locationTag.name,
    });
  }
  return labels;
};

export const submitAdapter: SubmitAdapter = ({ labels }) => {
  const subjectKeys: string[] = [];
  const subjectValues: string[] = [];
  let location: string | undefined = undefined;

  labels.forEach(label => {
    if (label.type === 'location') {
      location = label.name;
    } else {
      subjectKeys.push(SUBJECT_TAG_IDS[label.type]);
      subjectValues.push(label.name);
    }
  });

  return {
    // when the user removes or doesn't use the location_tag it's undefined
    // but POST uses JSON.stringify and JSON.stringify removes fields with undefined values
    // so, in order to remove it or show it's not being used, we convert to null
    location_tag: location ?? null,
    subject_tag_types: subjectKeys,
    subject_tags: subjectValues,
  };
};
